import { ValueTypesOf } from './valueTypesOf';

export const mapOf = <Arr extends readonly any[]>(
	arr: Arr,
): Record<ValueTypesOf<Arr>, ValueTypesOf<Arr>> => {
	return arr.reduce((acc, key) => ({ ...acc, [key]: key }), {});
};
